import { render, staticRenderFns } from "./BusinessListPage.vue?vue&type=template&id=453984f4&"
import script from "./BusinessListPage.vue?vue&type=script&lang=js&"
export * from "./BusinessListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports